import React, {useEffect, useState} from 'react';
import transformReactCodeToJSON from "../functions/transformReactCodeToJSON";

const Transform = () => {
    const [code, setCode] = useState('');
    const [json, setJson] = useState();
    useEffect(() => {
        setJson(transformReactCodeToJSON(code));
    }, [code])
    return (
        <div className='transform-container flex col gap-sm max-w'>
            <h2>Transform ReactJS components to JSON</h2>
            <div className='input-container'>
                <h3>Input:</h3>
                <textarea
                    value={code}
                    onChange={(event) => setCode(event.target.value)}
                />
            </div>
            <div className='output-container'>
                <h3>Output:</h3>
                <pre>
                    {json}
                </pre>
            </div>
        </div>
    );
};

export default Transform;